import { fetchBase } from "./base";

export interface LoginParams {
  code: string; // WorkOS authorization code
}

export interface LoginResponse {
  token: string;
}

export const login = (params: LoginParams): Promise<string> => {
  return fetchBase<LoginResponse>("/auth/login", {
    method: "POST",
    body: JSON.stringify(params),
  }).then((res) => {
    localStorage.setItem("ptkr-token", res.token);
    return res.token;
  });
};

export const check = (): Promise<any> => {
  return fetchBase<any>("/auth/check");
};

export interface RefreshResponse {
  token: string;
}

export const refresh = (): Promise<string> => {
  return fetchBase<RefreshResponse>("/auth/refresh", {
    method: "POST",
  }).then((res) => {
    localStorage.setItem("ptkr-token", res.token);
    return res.token;
  });
};
